/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
// Show the first tab and hide the rest
$('#tabs-nav-courses li:first-child').addClass('active');
$('.tab-content-courses').hide();
$('.tab-content-courses:first').show();

// Click function
$('#tabs-nav-courses li').click(function(){
  $('#tabs-nav-courses li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content-courses').hide();
  
  var activeTab = $(this).find('a.tab-click-desktop').attr('href');
  $(activeTab).fadeIn();
  return false;
});
});

$('#tabs-nav-courses li a.tab-click-mobile').on('click',function(e) {
   e.preventDefault();
   var url = $(this).attr('href'); 
   window.open(url,'_blank'); 
   return false;  
})



$(document).ready(function(){
	grid_height();	
  var url = window.location.href;
if(url.indexOf('/cart') > -1){
  window.location.href = $.cookie('url');
  
}else{
  console.log(url);
  $.cookie('url',url,{path:'/'});
}
});

 $(document).on('click','.ctm_add_cart',function(e){
        e.preventDefault();
        var form = $(this).closest('form');
//         $(this).text('Adding...');
        $(this).addClass('prod_adding');
        var price = $(this).data('price');
        var splt_last_price = parseInt(price.split('.')[1]);
        if(splt_last_price > 0){
           
        }else{
          price = $(this).data('price').split('.')[0];
        }
        form.find('.err_msg').remove();
        var _this = $(this);
        $.ajax({
          method: "post",
          url: "/cart/add.js",
          data: form.serialize(),
          dataType: "json",
          success: function(data){
            console.log(data);
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: form.find('[name=id]').val(),
                quantity: parseInt(form.find('[name="quantity"]').val())
              }
            }))
//             _this.text('Thank you!');
            _this.removeClass('prod_adding');
            _this.addClass('prod_addded');
            setTimeout(function(e){
             
              _this.removeClass('prod_addded');
            },2000)
          },
          error: function(err){
            var err_msg = err.responseJSON.description
            form.append('<p class="err_msg">'+err_msg+'</p>');
           
            _this.removeClass('prod_addded prod_adding');
            setTimeout(function(e){
              form.find('.err_msg').remove();
            },2000)
          }
        })
		return false;
      })


   document.addEventListener("DOMContentLoaded", function() {
        var endlessScroll = new Ajaxinate({
          callback: function(e){
           grid_height();
           $('.jdgm-prev-badge__text').each(function(e){
             var text = $(this).text();
             if(text.indexOf('review') > -1){
               var val = text.split('review')[0].trim();
               $(this).text('('+val+')');
             }
           })
          }
        });
      
      });

$(window).on('load',function(e) {
  var heightarray = new Array();
    $('.collection-height-cover').removeAttr('style');
    $('.collection-height-cover').each(function() {
          var height = $(this).outerHeight();
        heightarray.push(height);
      });
    var maxheight = Math.max.apply(Math,heightarray);
    $('.collection-height-cover').height(maxheight);
     
     var rec_mainheight = 0;
     $('[data-section-type="product-recommendations"] .Carousel__Cell .ProductItem').each(function(e){
       var height = $(this).height();
       if(rec_mainheight <= height){
         rec_mainheight = height;
       }
     })
     console.log('demo 455687...',(rec_mainheight+5));
     $('[data-section-type="product-recommendations"] .flickity-viewport').css('height',rec_mainheight+'px');
  setTimeout(function(params) {
  var heightarray = new Array();
    $('.collection-height-cover').removeAttr('style');
    $('.collection-height-cover').each(function() {
          var height = $(this).outerHeight();
        heightarray.push(height);
      });
    var maxheight = Math.max.apply(Math,heightarray);
    $('.collection-height-cover').height(maxheight);
     
     var rec_mainheight = 0;
     $('[data-section-type="product-recommendations"] .Carousel__Cell .ProductItem').each(function(e){
       var height = $(this).height();
       if(rec_mainheight <= height){
         rec_mainheight = height;
       }
     })
     console.log('demo 455687...',(rec_mainheight+5));
     $('[data-section-type="product-recommendations"] .flickity-viewport').css('height',rec_mainheight+'px');
     console.log('height added')
  },1500)
})



 var inter = setInterval(function(e) {
    var heightarray = new Array();
    $('.collection-height-cover').removeAttr('style');
    $('.collection-height-cover').each(function() {
        var height = $(this).outerHeight();
        heightarray.push(height);
    });
    var maxheight = Math.max.apply(Math,heightarray);
    $('.collection-height-cover').height(maxheight);
  
    $('.flickity-viewport').each(function(e){
      var mainheight = 0;
      mainheight = $(this).find('.Carousel__Cell:first-child').height();
      console.log()
      $(this).css('height',mainheight+'px')
    });
  
  },10)
setTimeout(function(e) {
 clearInterval(inter) 
},4000)

$(window).on('load',function(e) {
    grid_height();
    var max_height = 0;
    var max_top = 0;
    $('#courses-tab-scroll .courses-slider-thumb-bottom .flickity-slider .courses-slider-thumb-item img').each(function(e) {
      var height = $(this).height();
      if(max_height < height){
         max_height = height; 
      }  
    })
    
    $('#courses-tab-scroll .courses-slider-thumb-bottom .flickity-slider .courses-slider-thumb-item .h2').each(function(e) {
      var height = $(this).height();
      if(max_top < height){
         max_top = height; 
      }  
    })
    
    $('body').append('<style>.courses-slider-thumb:after, .courses-slider-thumb:before{height:'+max_height+'px !Important; top: '+max_top+'px !important}</style>'); 

    var prev_len = $('.courses-slider-thumb-bottom .flickity-prev-next-button.previous[disabled]').length;
    if(prev_len > 0){
      $('.courses-slider-thumb-bottom .courses-arrow a.courses-slider-arrow-prev').addClass('ctm_disabled');
    }else{
      $('.courses-slider-thumb-bottom .courses-arrow a.courses-slider-arrow-prev').removeClass('ctm_disabled');
    }
    
    var next_len = $('.courses-slider-thumb-bottom .flickity-prev-next-button.next[disabled]').length;
    if(next_len > 0){
      $('.courses-slider-thumb-bottom .courses-arrow a.courses-slider-arrow-next').addClass('ctm_disabled');
    }else{
      $('.courses-slider-thumb-bottom .courses-arrow a.courses-slider-arrow-next').removeClass('ctm_disabled');
    }

    var coursessliderheight = 0;
    $('.courses-tab-main-slider .courses-slider .courses-tab-main-slider-c-item').each(function(e) {
       var height = $(this).height();
       if(coursessliderheight < height){
          coursessliderheight = height; 
       } 
    })
    
    $('.courses-tab-main-slider .courses-slider .flickity-viewport').css('height',coursessliderheight);

  
    var coursessliderheight = 0;
    $('.courses-slider-thumb-bottom .courses-slider-thumb-item').each(function(e) {
       var height = $(this).height();
       if(coursessliderheight < height){
          coursessliderheight = height; 
       } 
    })
    
    $('.courses-slider-thumb-bottom .courses-slider-thumb .flickity-viewport').css('height',coursessliderheight);
  
  
})



$(window).resize(function(){
  
  setTimeout(function(e) {
    var heightarray = new Array();
	$('.collection-height-cover').removeAttr('style');
	$('.collection-height-cover').each(function() {
        var height = $(this).outerHeight();
		heightarray.push(height);
    });
    
	var maxheight = Math.max.apply(Math,heightarray);
	$('.collection-height-cover').height(maxheight);
    $('.ProductList-custom .flickity-viewport').each(function(e){
      var highestBox = 0;
        $(this).find('.Carousel__Cell').each(function(){  
          if($(this).height() > highestBox){  
          highestBox = $(this).height();  
        }
      });    
      console.log(highestBox)
      $(this).css('height',highestBox+'px');
   })
  },300)
});

function grid_height(){
	var heightarray = new Array();
	$('.collection-height-cover').removeAttr('style');
	$('.collection-height-cover').each(function() {
        var height = $(this).outerHeight();
		heightarray.push(height);
    });
	var maxheight = Math.max.apply(Math,heightarray);
	$('.collection-height-cover').height(maxheight);
}




/* JQuery Code from:
 http://www.findsourcecode.com/jquery/how-to-count-number-of-characters-in-textarea-jquery/ */

$( document ).ready(function() {
  var maxChars = 200;
  var textLength = 0;
  var comment = "";
  var outOfChars = 'You have reached the limit of ' + maxChars + ' characters';

  /* initalize for when no data is in localStorage */
  var count = maxChars;
  $('#characterLeft').text(count + ' characters left');

  /* fix val so it counts carriage returns */
  $.valHooks.textarea = {
    get: function(e) {
      return e.value.replace(/\r?\n/g, "\r\n");
    }
  };

  function checkCount() {
    textLength = $('#comment').val().length;
    if (textLength >= maxChars) {
      $('#characterLeft').text(outOfChars);
    }
    else {
      count = maxChars - textLength;
      $('#characterLeft').text(count + ' characters left');
    }
  }

  /* on keyUp: update #characterLeft as well as count & comment in localStorage */
  $('#comment').keyup(function() {
    checkCount();
    comment = $(this).val();
    localStorage.setItem("comment", comment);
  });

  /* on pageload: get check for comment text in localStorage, if found update comment & count */
  if (localStorage.getItem("comment") != null) {
    $('#comment').text(localStorage.getItem("comment"));
    checkCount();
  }    
});


$(document).on('click', '.button-group-banne a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 100
    }, 500);
});


